import React, { Fragment, useEffect } from 'react';
import { App, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { Dropdown } from '../../../../../shared/ui/Dropdown';
import { FeedbacksProps } from '../service/feedback.interface';
import { useCloseFeedbackMutation } from '../service/adminFeedbackApi';

export const TableActions = (props: FeedbacksProps) => {
    const { id, status } = props;

    const { notification } = App.useApp();

    const [closeFeedback, { isSuccess, error }] = useCloseFeedbackMutation();

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Успешно',
                placement: 'top',
            });
            navigate(-1);
        }
    }, [isSuccess]);

    useEffect(() => {
        if (error) {
            notification.error({
                message: (error as any).data.message || 'Что-то пошло не так',
                placement: 'top',
            });
        }
    }, [error]);

    const navigate = useNavigate();

    return (
        <>
            {status === 'Новый' && (
                <StyledDropdown
                    dropdownContent={() => (
                        <Fragment>
                            <Button
                                type='text'
                                onClick={() => navigate(`${id}`)}
                            >
                                Ответить
                            </Button>
                            <Button
                                type='text'
                                onClick={() => closeFeedback(id)}
                            >
                                Закрыть обращение
                            </Button>
                        </Fragment>
                    )}
                >
                    <Button type='default'>
                        Действие <DownOutlined />
                    </Button>
                </StyledDropdown>
            )}
            {status !== 'Новый' && (
                <Button type='text' onClick={() => navigate(`${id}`)}>
                    Просмотреть
                </Button>
            )}
        </>
    );
};

const StyledDropdown = styled(Dropdown)`
    margin-left: auto;
    cursor: pointer;

    button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        border: none;
        box-shadow: none;
        padding: 0;

        span:nth-child(1) {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`;
